/**
 * Pay Rule API Contract
 *
 * Defines the oRPC contract for Pay Rules - company-level pay rate adjustments
 * based on conditions (holidays, weekends, late shifts, etc.).
 */
import { oc } from "@orpc/contract";
import { z } from "zod";
import { CreatePayRuleInputSchema, UpdatePayRuleInputSchema, PayRuleResponseSchema, ListPayRulesResponseSchema, } from "@hourly/api/payRule";
import { uuidSchema } from "@hourly/api/validation-common";
// ============ Contract Definitions ============
// Create a pay rule
const createPayRule = oc
    .route({
    method: "POST",
    path: "/pay-rules",
    summary: "Create a new pay rule",
    tags: ["Pay Rules"],
    successStatus: 201,
})
    .input(CreatePayRuleInputSchema)
    .output(PayRuleResponseSchema);
// Get a pay rule by ID
const getPayRule = oc
    .route({
    method: "GET",
    path: "/pay-rules/{id}",
    summary: "Get a pay rule by ID",
    tags: ["Pay Rules"],
})
    .input(z.object({ id: uuidSchema }))
    .output(PayRuleResponseSchema);
// List pay rules for a company
const listPayRules = oc
    .route({
    method: "GET",
    path: "/pay-rules",
    summary: "List all pay rules for a company",
    tags: ["Pay Rules"],
})
    .input(z.object({
    isActive: z.stringbool().optional(),
}))
    .output(ListPayRulesResponseSchema);
// Update a pay rule
const updatePayRule = oc
    .route({
    method: "PUT",
    path: "/pay-rules/{id}",
    summary: "Update a pay rule",
    tags: ["Pay Rules"],
})
    .input(z.object({ id: uuidSchema }).merge(UpdatePayRuleInputSchema))
    .output(PayRuleResponseSchema);
// Delete a pay rule
const deletePayRule = oc
    .route({
    method: "DELETE",
    path: "/pay-rules/{id}",
    summary: "Delete a pay rule",
    tags: ["Pay Rules"],
    successStatus: 204,
})
    .input(z.object({ id: uuidSchema }))
    .output(z.void());
// ============ Export Contract ============
export const payRuleContract = {
    create: createPayRule,
    get: getPayRule,
    list: listPayRules,
    update: updatePayRule,
    delete: deletePayRule,
};
//# sourceMappingURL=payRule.js.map